import { render } from "./zdsx.vue?vue&type=template&id=233fedbb&scoped=true&ts=true"
import script from "./zdsx.vue?vue&type=script&lang=ts"
export * from "./zdsx.vue?vue&type=script&lang=ts"

import "./zdsx.vue?vue&type=style&index=0&id=233fedbb&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233fedbb"]])

export default __exports__